﻿import { IUnitsConversionSet } from "./Converters/UnitsConverter/IUnitsConverter";
import { IStationValueFormatter } from "./Formatters/IStationValueFormatter";
import { InfluxDataWrapper } from "./InfluxDb/InfluxDataWrapper";
import { getGroupData } from "./InfluxDb/InfluxDb";
import { MainSite } from "./MainSite";
import { Station } from "./Model/Station";
import { WarningGroup } from "./Model/WarningGroup";

export class PopupChartable {
    constructor(public mainSite: MainSite, protected station?: Station, protected valueFormatter?: IStationValueFormatter) {
        this.sensorLabelBox = $('<span>N/A</span>');
        this.timeStampBox = $('<span>N/A</span>');
    }

    protected popup: JQuery;
    protected warningGroup: WarningGroup;
    protected sensorLabelBox: JQuery;
    protected timeStampBox: JQuery;
    private chartContainer: JQuery;
    private dateSelected: JQuery;
    private loadingMessage: JQuery;
    private noDataLabel: JQuery;

    protected chart: __Highcharts.ChartObject;

    public renderPopup(e: Pick<JQueryMouseEventObject, "pageX" | "pageY">, openPopups: string[] = null): boolean {
        if (this.popup || (openPopups && openPopups.indexOf(this.station.Id + "_" + this.valueFormatter.getId()) > -1)) {
            $('.midi_siteObsPage_popup').not(this.popup).css('z-index', '100');
            $(this.popup).css('z-index', '1000');
            return true;
        }

        this.popup = $('<div class="midi_siteObsPage_popup modal-content"></div>')
            .appendTo('body');

        if (openPopups) {
            openPopups.push(this.station.Id + "_" + this.valueFormatter.getId());
        }

        $('.midi_siteObsPage_popup').not(this.popup).css('z-index', '100');
        $(this.popup).css('z-index', '1000');

        var oldTop;
        var oldLeft;

        // TODO: Doesn't actually seem to work
        var maximise = $('<a class="midi_siteObsPage_popup_maximise midi_siteObsPage_popup_tools" href="#"></a>')
            .html('<i class= "fa fa-expand"> </i>')
            .attr('title', 'Expand')
            .click(() => {
                this.popup.addClass('midi_siteObsPage_popup_maximised');
                oldLeft = this.popup.css('left');
                oldTop = this.popup.css('top');
                this.popup.css('top', '10%');
                this.popup.css('left', '5%');
                maximise.hide();
                restore.show();
                $(window).resize();
                return false;
            });

        var restore = $('<a class="midi_siteObsPage_popup_maximise midi_siteObsPage_popup_tools" href="#"></a>')
            .html('<i class= "fa fa-compress"> </i>')
            .css('display', 'none')
            .attr('title', 'Restore')
            .click(() => {
                this.popup.removeClass('midi_siteObsPage_popup_maximised');
                this.popup.css('top', oldTop);
                this.popup.css('left', oldLeft);
                restore.hide();
                maximise.show();
                $(window).resize();
                return false;
            });

        this.popup.append(maximise);
        this.popup.append(restore);

        this.popup.append(
            $('<a class="midi_siteObsPage_popup_close midi_siteObsPage_popup_tools" href="#"></a>')
                .html('<i class= "fa fa-times"></i>')
                .attr('title', 'Close')
                .click(() => {
                    this.popup.remove();
                    this.popup = null;
                    if (openPopups) {
                        openPopups.splice(openPopups.indexOf(this.station.Id + "_" + this.valueFormatter.getId()), 1);
                    }
                    return false;
                })
        );

        this.popup.append(
            $('<div class="midi_siteObsPage_popup_station"></div>').text(this.station.Label));

        this.popup.append(
            $('<div class="midi_siteObsPage_popup_title">' + this.valueFormatter.getShortName() + ' <span class="midi_siteObsPage_popup_units">' + ((this.valueFormatter.getUnits()) ? this.valueFormatter.getUnits() : '') + '</span></div>'));

        this.popup.append($('<div class="midi_siteObsPage_popup_timestamp"></div>').append(this.timeStampBox));

        this.popup.append(
            $('<div class="midi_siteObsPage_popup_description"></div>').text(this.valueFormatter.getDescription()));

        this.popup.append(
            $('<div class="midi_siteObsPage_popup_sensor"></div>')
                .append($('<span>Sensor: </span>'))
                .append(this.sensorLabelBox));

        this.popup
            .draggable({ cancel: ".midi_siteObsPage_popup_chart_container" })
            .mousedown(() => {
                $('div.midi_siteObsPage_popup').not(this.popup).css('z-index', '100');
                $(this.popup).css('z-index', '1000');
            });

        if (!this.valueFormatter.plottable()) {
            $('<p><em>This parameter is not plottable.</em></p>').appendTo(this.popup);
        } else {
            var fromMoment = moment.utc().add('d', -1);

            var timeZoneString;

            timeZoneString = this.mainSite.getTimeZoneString();

            this.loadingMessage = $('<p><em>Loading data...</em></p>');
            this.loadingMessage.css('text-align', 'center');
            this.loadingMessage.appendTo(this.popup);

            this.noDataLabel = $('<p><em>This parameter has returned no data in the last week.</em></p>');

            // Fetch historical and forecast data from InfluxDB
            getGroupData(
                // Parameters for historical data fetch
                this.station.Id,
                "Forecast_" + this.valueFormatter.getId(),
                moment.utc().valueOf(),
                moment.utc().add('d', 1).valueOf(),

                // Callback function handling both historical and forecast data
                (err, forecastData) => {
                    getGroupData(
                        // Parameters for current data fetch
                        this.station.Id,
                        this.valueFormatter.getId(),
                        fromMoment.valueOf(),
                        moment.utc().valueOf(),

                        // Callback handling combined historical and forecast data
                        (err: any, data: InfluxDataWrapper) => {
                            // Remove loading indicator
                            this.loadingMessage.remove();

                            // Check if forecast data exists
                            let gotForecastData = forecastData.Data !== null && forecastData.Data.length > 0;

                            // Handle case where historical data doesn't exist but forecast does
                            if ((data.Data === null || data.Data.length < 1) && gotForecastData) {
                                // Display no data label and exit early
                                this.noDataLabel.appendTo(this.popup);
                                return;
                            }

                            // Initialize units conversion system
                            let unitsConversionSet: IUnitsConversionSet | null =
                                MainSite.getUnitConverter().getConversionSet(
                                    this.valueFormatter.getParameterGroupInfo()?.Units ??
                                    this.valueFormatter.getUnits(),
                                    this.valueFormatter.getId()
                                );

                            // Apply unit conversions to data if conversion set exists
                            if (unitsConversionSet) {
                                // Convert historical data values
                                data.Data = data.Data.map(x => {
                                    if (Array.isArray(x) && x.length == 2) {
                                        return [x[0], unitsConversionSet.convertValue(x[1])];
                                    }
                                    return x;
                                });

                                // Convert forecast data values if available
                                if (forecastData && forecastData.Data && Array.isArray(forecastData.Data)) {
                                    forecastData.Data = forecastData.Data.map(x => {
                                        if (Array.isArray(x) && x.length == 2) {
                                            return [x[0], unitsConversionSet.convertValue(x[1])];
                                        }
                                        return x;
                                    });
                                }
                            }

                            // Create navigation bar structure
                            var plottingNavBar = $('<nav class="nav navbar-default midi_siteObsPage_popup_navBar"></nav>')
                                .appendTo(this.popup);

                            // Create grouping navigation controls
                            var groupingNavBarList = $('<ul id="grouping_nav" class="nav navbar-nav"></ul>')
                                .appendTo(plottingNavBar)
                                .append($('<div></div>').text("Grouping:"));

                            // Add grouping options with click handlers
                            var highGrouping = $('<li class="midi_siteObsPage_popup_navBar_listItem"><a>High</a></li>')
                                .click((e: JQueryMouseEventObject) => {
                                    this.setGrouping("high");
                                    $('#grouping_nav').children('.midi_siteObsPage_popup_navBar_listItem')
                                        .removeClass("active");
                                    $(e.target).parent().addClass("active");
                                })
                                .appendTo(groupingNavBarList);

                            $('<li class="midi_siteObsPage_popup_navBar_listItem"><a>Average</a></li>')
                                .click((e: JQueryMouseEventObject) => {
                                    this.setGrouping("average");
                                    $('#grouping_nav').children('.midi_siteObsPage_popup_navBar_listItem')
                                        .removeClass("active");
                                    $(e.target).parent().addClass("active");
                                })
                                .appendTo(groupingNavBarList);

                            $('<li class="midi_siteObsPage_popup_navBar_listItem"><a>Low</a></li>')
                                .click((e: JQueryMouseEventObject) => {
                                    this.setGrouping("low");
                                    $('#grouping_nav').children('.midi_siteObsPage_popup_navBar_listItem')
                                        .removeClass("active");
                                    $(e.target).parent().addClass("active");
                                })
                                .appendTo(groupingNavBarList);

                            // Create time navigation controls
                            var plottingNavBarList = $('<ul id="time_nav" class="nav navbar-nav"></ul>')
                                .appendTo(plottingNavBar);

                            // Add time period selection options
                            $('<li class="midi_siteObsPage_popup_navBar_listItem"><a>12 Hours</a></li>')
                                .click((e: JQueryMouseEventObject) => {
                                    this.requestDataForTimePeriod('h', 12, $(e.target));
                                    //this.updateChart('h', 12, $(e.target));
                                })
                                .appendTo(plottingNavBarList);

                            this.dateSelected = $('<li class="midi_siteObsPage_popup_navBar_listItem active"><a>24 Hours</a></li>')
                                .click((e: JQueryMouseEventObject) => {
                                    this.requestDataForTimePeriod('d', 1, $(e.target));
                                    //this.updateChart('d', 1, $(e.target));
                                })
                                .appendTo(plottingNavBarList);

                            $('<li class="midi_siteObsPage_popup_navBar_listItem"><a>2 Days</a></li>')
                                .click((e: JQueryMouseEventObject) => {
                                    this.requestDataForTimePeriod('d', 2, $(e.target));
                                    //this.updateChart('d', 2, $(e.target));
                                })
                                .appendTo(plottingNavBarList);

                            $('<li class="midi_siteObsPage_popup_navBar_listItem"><a>7 Days</a></li>')
                                .click((e: JQueryMouseEventObject) => {
                                    this.requestDataForTimePeriod('d', 7, $(e.target));
                                    //this.updateChart('d', 7, $(e.target));
                                })
                                .appendTo(plottingNavBarList);

                            $('<li class="midi_siteObsPage_popup_navBar_listItem"><a>30 Days</a></li>')
                                .click((e: JQueryMouseEventObject) => {
                                    this.requestDataForTimePeriod('d', 30, $(e.target));
                                    //this.updateChart('d', 30, $(e.target));
                                })
                                .appendTo(plottingNavBarList);

                            // Create chart container
                            this.chartContainer = $('<div class="midi_siteObsPage_popup_chart_container"></div')
                                .appendTo(this.popup);

                            // Add padding points to data for better visualization
                            data.Data.unshift([fromMoment.valueOf(), null]);
                            data.Data.push([moment.utc().valueOf(), null]);

                            // Initialize chart configuration
                            var axisId = data.ParameterId;

                            // Configure plot bands for warnings (currently commented out)
                            var plotBands = [];

                            /* 
                            // Warning system configuration (commented out)
                            if (this.warningGroup && this.warningGroup.Rules[this.valueFormatter.getId()]) {
                                var warningRuleSet: WarningRuleSet = this.warningGroup.Rules[this.valueFormatter.getId()];
                
                                if (warningRuleSet.Gt_LowPriority !== null) {
                                    plotBands.push({
                                        from: warningRuleSet.Gt_LowPriority,
                                        to: warningRuleSet.Gt_MediumPriority,
                                        color: '#FFFFE0'
                                    });
                                }
                
                                // ... rest of warning configuration ...
                            }
                            */

                            // Initialize Highcharts instance
                            this.chartContainer.highcharts('StockChart', <any>{
                                chart: {
                                    zoomType: 'x'
                                },
                                credits: {
                                    enabled: false
                                },
                                exporting: {
                                    enabled: false
                                },
                                legend: {
                                    enabled: false
                                },
                                rangeSelector: {
                                    enabled: false,
                                    selected: 1
                                },
                                scrollbar: {
                                    enabled: false
                                },
                                plotOptions: {
                                    series: {
                                        events: {
                                            legendItemClick: function () {
                                                return false;
                                            }
                                        },
                                        showInNavigator: true
                                    },
                                    line: {
                                        dataGrouping: {
                                            approximation: "high"
                                        }
                                    }
                                },
                                xAxis: {
                                    type: 'datetime',
                                    ordinal: false,
                                },
                                yAxis: {
                                    opposite: false,
                                    plotBands: plotBands,
                                    min: this.valueFormatter.axisMin(),
                                    max: this.valueFormatter.axisMax()
                                },
                                tooltip: {
                                    xDateFormat: '%Y-%m-%d %H:%M:%S ' + timeZoneString,
                                    valueDecimals: 2
                                },
                                series: [{
                                    name: `${this.valueFormatter.getShortName()} (${this.valueFormatter.getUnits()})`,
                                    id: data.ParameterId,
                                    data: data.Data,
                                    lineWidth: (() => {
                                        if (!this.valueFormatter.plotLines()) {
                                            return 0;
                                        }
                                        return 1;
                                    })(),
                                    marker: {
                                        enabled: !this.valueFormatter.plotLines(),
                                        radius: 3
                                    },
                                    gapSize: 7200000,// 2 hours in miliseconds
                                    gapUnit: "value"
                                },
                                {
                                    name: `${this.valueFormatter.getShortName()} (${this.valueFormatter.getUnits()}) [Forecast]`,
                                    id: forecastData.ParameterId,
                                    data: forecastData.Data,
                                    lineWidth: (() => {
                                        if (!this.valueFormatter.plotLines()) {
                                            return 0;
                                        }
                                        return 1;
                                    })(),
                                    marker: {
                                        enabled: !this.valueFormatter.plotLines(),
                                        radius: 3
                                    }
                                }]
                            });

                            // Store chart instance reference
                            this.chart = this.chartContainer.highcharts();

                            // Set initial active grouping
                            highGrouping.addClass('active');
                        },
                        this.valueFormatter.getSensorId()
                    );
                }
            );
        }

        var mouseX = e.pageX;
        var mouseY = e.pageY;
        var padding: number = 0;

        if (mouseY + (this.popup.outerHeight(true) + 200) >= ($(window).height() - padding) && mouseX + this.popup.outerWidth(true) >= ($(window).width() - padding)) {
            this.popup
                .css({
                    "top": Math.max(60, (mouseY - (this.popup.outerHeight(true) + 200) - padding)),
                    "left": mouseX - this.popup.outerWidth(true) - padding

                })
        }

        else if (mouseY + (this.popup.outerHeight(true) + 200) >= ($(window).height() - padding)) {
            this.popup
                .css({
                    "top": Math.max(60, (mouseY - (this.popup.outerHeight(true) + 200) - padding)),
                    "left": mouseX
                })
        }

        else if (mouseX + this.popup.outerWidth(true) >= ($(window).width() - padding)) {
            this.popup
                .css({
                    "top": mouseY,
                    "left": mouseX - this.popup.outerWidth(true) - padding

                })
        }

        else {
            this.popup
                .css({
                    "top": mouseY,
                    "left": mouseX
                })

        }

        return true;
    }

    //private updateChart(timePeriod: moment.unitOfTime.DurationConstructor, quantity: number, selectedLabel: JQuery) {
    //    console.log('[PopupChartable:HERE2] Doing requestDataForTimePeriod()')
    //    console.log('[PopupChartable:HERE2] selectedLabel: ', selectedLabel)

    //    selectedLabel.parent().addClass("active");
    //    this.dateSelected.removeClass("active");
    //    this.dateSelected = selectedLabel.parent();
    //    this.dateSelected.addClass('active');

    //    this.chartContainer.remove();
    //    this.loadingMessage.appendTo(this.popup);

    //    this.requestDataForTimePeriod(timePeriod, quantity);
    //}

    private requestDataForTimePeriod(timePeriod: moment.unitOfTime.DurationConstructor, quantity: number, selectedLabel: JQuery) {
        console.log('[PopupChartable:HERE2] Doing requestDataForTimePeriod()')
        console.log('[PopupChartable:HERE2] selectedLabel: ', selectedLabel)

        selectedLabel.parent().addClass("active");
        this.dateSelected.removeClass("active");
        this.dateSelected = selectedLabel.parent();
        this.dateSelected.addClass('active');

        this.chartContainer.remove();
        this.loadingMessage.appendTo(this.popup);

        // Fetch historical and forecast data from InfluxDB
        getGroupData(
            // Parameters for historical data fetch
            this.station.Id,
            "Forecast_" + this.valueFormatter.getId(),
            moment.utc().valueOf(),
            moment.utc().add(timePeriod, quantity).valueOf(),

            // Callback function handling both historical and forecast data
            (err, forecastData) => {
                getGroupData(
                    // Parameters for current data fetch
                    this.station.Id,
                    this.valueFormatter.getId(),
                    moment.utc().add(timePeriod, -1 * quantity).valueOf(),
                    moment.utc().valueOf(),

                    // Callback handling combined historical and forecast data
                    (err: any, data: InfluxDataWrapper) => {
                        // Remove loading indicator
                        this.loadingMessage.remove();

                        // Check if forecast data exists
                        let gotForecastData = forecastData.Data !== null && forecastData.Data.length > 0;

                        // Handle case where historical data doesn't exist but forecast does
                        if ((data.Data === null || data.Data.length < 1) && gotForecastData) {
                            this.noDataLabel.appendTo(this.popup);
                            return;
                        }

                        // Initialize units conversion system
                        let unitsConversionSet: IUnitsConversionSet | null =
                            MainSite.getUnitConverter().getConversionSet(
                                this.valueFormatter.getParameterGroupInfo()?.Units ??
                                this.valueFormatter.getUnits(),
                                this.valueFormatter.getId()
                            );

                        // Apply unit conversions to data if conversion set exists
                        if (unitsConversionSet) {
                            console.log('[PopupChartable:HERE2] a');
                            // Convert historical data values
                            data.Data = data.Data.map(x => {
                                if (Array.isArray(x) && x.length == 2) {
                                    console.log('[PopupChartable:HERE2] b');
                                    return [x[0], unitsConversionSet.convertValue(x[1])];
                                }
                                return x;
                            });

                            // Convert forecast data values if available
                            if (forecastData && forecastData.Data && Array.isArray(forecastData.Data)) {
                                console.log('[PopupChartable:HERE2] c');
                                forecastData.Data = forecastData.Data.map(x => {
                                    if (Array.isArray(x) && x.length == 2) {
                                        console.log('[PopupChartable:HERE2] d');
                                        return [x[0], unitsConversionSet.convertValue(x[1])];
                                    }
                                    return x;
                                });
                            }
                        }

                        // Update chart data
                        var hours = timePeriod == 'h' ? quantity : quantity * 24;
                        this.setDateWithButtons(hours, gotForecastData ? forecastData.Data[forecastData.Data.length - 1] : null);

                        this.chart.series[0].update({
                            data: data.Data,
                        });
                        this.chart.series[1].update({
                            data: forecastData.Data
                        });

                        this.chartContainer.appendTo(this.popup);
                    },
                    this.valueFormatter.getSensorId()
                );
            }
        );
    }

    private setDateWithButtons(numberOfHours: number, lastForecastDp: any) {
        var from = moment.utc().subtract(numberOfHours, 'h'); // 00:00 UTC    
        let to: moment.Moment;

        if (lastForecastDp) {
            let lastTsUnixMiliSeconds = lastForecastDp[0] as number;
            let lastTsMoment = moment.unix(lastTsUnixMiliSeconds / 1000);

            to = moment.utc().add(numberOfHours, 'h');
            if (lastTsMoment.diff(to) < 0) {
                to = lastTsMoment;
            }
        }
        else {
            to = moment.utc();
        }

        this.chart.xAxis[0].setExtremes(from.valueOf(), to.valueOf());
    }

    private setGrouping(groupingApproximation: string) {
        var options = this.chart.options;
        (options.plotOptions.line as any).dataGrouping.approximation = groupingApproximation;
        this.chart = this.chartContainer.highcharts(options).highcharts();
    }

    public setSensor(sensorLabel: string) {
        this.sensorLabelBox.text(sensorLabel);
    }

    public setTimestamp(timestamp: number) {
        this.timeStampBox.text(this.mainSite.getDisplayTime(timestamp, this.mainSite.selectedRegion.TimeZone));
    }
}